/* unplugin-vue-components disabled */import __unplugin_components_3 from '/var/repos/bic-vue/src/components/common/SvgIcon.vue';
import __unplugin_components_2 from '/var/repos/bic-vue/src/components/common/button/ButtonGroup.vue';
import __unplugin_components_1 from '/var/repos/bic-vue/src/components/common/button/EditorButton.vue';
import __unplugin_components_0 from '/var/repos/bic-vue/src/components/configurator/topbar/PreviewToolbar.vue';
import "core-js/modules/web.dom-exception.stack.js";
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2deb50f9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "relative flex-1 overflow-hidden"
};
const _hoisted_2 = {
  class: "absolute flex bottom-6 right-10 gap-2 z-20"
};
import * as THREE from "three";
import { gsap } from "gsap";
import CameraControls from "camera-controls";
import { useConfiguratorStore } from '@/stores/configurator';
import { useConfigurationStore } from "@/stores/configurationModule";
import { useThemeStore } from "@/stores/theme";
import { useWindowSize } from '@vueuse/core';

// import Adapter from '@/services/adapter'
import useNodeClient from '@/composables/services/useNodeClient';
import useRenderer from "@/composables/3dPreview/useRenderer";
import useCamera from "@/composables/3dPreview/useCamera";
import useControls from "@/composables/3dPreview/useControls";
import useLights from "@/composables/3dPreview/useLights";
import use3dMouseSelect from "@/composables/3dPreview/use3dMouseSelect";
import useModel from "@/composables/3dPreview/model/useModel";
import useSceneHelpers from "@/composables/3dPreview/useSceneHelpers";
export default {
  __name: 'Preview3d',
  props: {
    isEditable: {
      require: false,
      type: Boolean,
      default: false
    },
    type: {
      require: true,
      type: String,
      default: 'Shipping'
    },
    width: {
      require: true,
      type: Number,
      default: 6
    },
    length: {
      require: true,
      type: Number,
      default: 6
    },
    depth: {
      require: true,
      type: Number,
      default: 6
    }
  },
  setup(__props) {
    const Adapter = useNodeClient();
    const {
      width: windowWidth
    } = useWindowSize();
    const configurationStore = useConfigurationStore();
    const configuratorStore = useConfiguratorStore();
    const {
      mobileBreakpoint
    } = storeToRefs(configuratorStore);

    // const { $eventBus } = useNuxtApp();
    const $eventBus = inject('bus');
    const themeStore = useThemeStore();
    const {
      theme
    } = storeToRefs(themeStore);

    // const isCameraMoving = ref(true);
    const hasHoverPanelChanged = ref(false);
    const isCameraMoving = ref(false);
    const isLidAnimationRunning = ref(false);
    const isResized = ref(false);
    const isThemeChanged = ref(false);
    const ssCameraDistanceFromBox = ref(14);
    const props = __props;
    const preview3dWrapperEl = ref(null);
    const preview3dContainerEl = ref(null);
    const textures = ref([]);
    const lidTimeline = ref(null);
    let model = null;
    let box = null;
    let clock = null;
    let stopAnim = null;
    let raycaster = null;
    let mouse = {};
    let renderer = null;
    let scene = null;
    let camera = null;
    let controls = null;
    let baseControlsDistance = null;
    let textureGlobals = {};
    const cameraPositionsRotateH = {
      front: Math.PI / 9,
      right: Math.PI / 2 - Math.PI / 9,
      middleRight: Math.PI / 2,
      back: Math.PI - Math.PI / 9,
      trueBack: Math.PI,
      left: 1.5 * Math.PI - Math.PI / 9,
      quarterLeft: 1.5 * Math.PI + Math.PI / 12,
      middleLeft: -(Math.PI / 2),
      backLeft: Math.PI + Math.PI / 6,
      backRight: Math.PI - Math.PI / 6
    };
    const cameraPositionsRotateV = {
      top: Math.PI / 16,
      high: Math.PI / 6,
      middleHigh: Math.PI / 4,
      middle: Math.PI / 2,
      low: Math.PI - Math.PI / 6
    };
    const {
      fabricCanvases,
      offscreenCanvasIds,
      // geometrySvg,

      activePanel,
      hoveredPanel,
      isActivePanelInside,
      isOutsideCanvasActive,
      isHoveredPanelInside,
      insideMaterialColor,
      outsideMaterialColor,
      hasInsidePrinting,
      box: boxFromStore,
      configurationScreenshotData,
      haveCanvasesBeenModified
    } = storeToRefs(configurationStore);
    const {
      setConfigurationScreenShotData,
      setHaveCanvasesBeenModified
    } = useConfigurationStore();
    const lidBoolean = ref(true);
    function handleBoxLid() {
      lidBoolean.value = !lidBoolean.value;
    }
    function createBlankCanvas(box) {
      const blankCanvas = document.createElement('canvas');
      blankCanvas.width = box.canvasWidth;
      blankCanvas.height = box.canvasHeight;
      const blankCanvasCtx = blankCanvas.getContext('2d');
      blankCanvasCtx.fillStyle = "white";
      blankCanvasCtx.fillRect(0, 0, blankCanvas.width, blankCanvas.height);
      blankCanvas.style.display = 'none';
      return blankCanvas;
    }
    function setColorsFromTheme() {
      if (theme.value === 'light') {
        renderer.setClearColor(0xF3F3F4);
      }
      if (theme.value === 'dark') {
        renderer.setClearColor(0x242541);
      }
    }
    function initScene() {
      renderer = useRenderer(preview3dWrapperEl.value);
      scene = new THREE.Scene();
      clock = new THREE.Clock();
      camera = useCamera(box, preview3dWrapperEl.value);
      scene.add(camera);
      controls = useControls(renderer, camera);
      controls.addEventListener('update', () => {
        isCameraMoving.value = true;
      });

      // console.log('controls', controls)

      useLights(scene, camera);

      // useSceneHelpers(scene)

      controls.update();

      // @TEMP
      if (props.isEditable) {
        use3dMouseSelect(raycaster, renderer, camera, mouse, scene, box, preview3dContainerEl.value);
      }

      // renderer.domElement.classList.add('preview-3d-canvas');
      preview3dContainerEl.value.appendChild(renderer.domElement);
    }
    function initBoxObj() {
      box = boxFromStore.value;
    }
    function initMouse() {
      if (props.isEditable) {
        use3dMouseSelect(raycaster, renderer, camera, mouse, scene, box, preview3dContainerEl.value);
      }
    }
    function initBox(lidTimeline) {
      let _offscreenCanvas = document.querySelector(`#${offscreenCanvasIds.value[0]}`);
      const _insideOffscreenCanvas = document.querySelector(`#${offscreenCanvasIds.value[1]}`);
      if (!props.isEditable) {
        const blankCanvas = createBlankCanvas(box);
        document.body.append(blankCanvas);
        _offscreenCanvas = blankCanvas;
      }
      textures.value = [];
      model = useModel(box, lidTimeline, textureGlobals, scene, textures);
      lidTimeline.value?.eventCallback('onUpdate', () => {
        isLidAnimationRunning.value = true;
      });
      setCameraDistance();

      //  ANIMATION
      // ---------------------------------------------------
      let lastExecutionTime = 0;
      function setCameraDistance() {
        lidTimeline.value?.progress(1);
        let bbox = new THREE.Box3().setFromObject(model);
        const center = new THREE.Vector3();
        bbox.getCenter(center);
        const bsphere = bbox.getBoundingSphere(new THREE.Sphere(center));
        const radius = bsphere.radius;
        baseControlsDistance = radius * 3;
        controls.distance = baseControlsDistance;
        lidTimeline.value?.progress(0);
      }
      function animate() {
        if (stopAnim) {
          return;
        }
        const delta = clock.getDelta();
        const currentTime = Date.now();
        if (haveCanvasesBeenModified.value || isLidAnimationRunning.value || isCameraMoving.value || hasHoverPanelChanged.value || isResized.value || isThemeChanged.value) {
          lastExecutionTime = currentTime;
          textures.value.forEach((texture, index) => {
            // console.log('areTexturesUpdating')

            // disable controls
            const canvas = fabricCanvases.value[index];
            if (!canvas) {
              return;
            }
            canvas.interactive = false;
            canvas.renderAll();

            // update textures
            texture.needsUpdate = true;
            renderer.render(scene, camera);

            // enable controls
            canvas.interactive = true;
            canvas.renderAll();
          });
          // console.log('3d rendering...')
          setHaveCanvasesBeenModified(false);
          isCameraMoving.value = false;
          hasHoverPanelChanged.value = false;
          isLidAnimationRunning.value = false;
          isResized.value = false;
          isThemeChanged.value = false;
        }
        controls.update(delta);
        // renderer.render(scene, camera);
        requestAnimationFrame(animate);
      }
      stopAnim = false;
      animate();
      // ---------------------------------------------------
    }
    function takeScreenshot() {
      const lidProgress = lidTimeline.value?.progress();
      lidTimeline.value.progress(0);
      removeHoverPanelIndication();
      fabricCanvases.value.forEach(canvas => {
        canvas.interactive = false;
        // console.log('canvas', canvas)
      });
      const sceneClone = scene.clone(true);
      fabricCanvases.value.forEach(canvas => {
        canvas.interactive = true;
        // console.log('canvas', canvas)
      });
      let cameraClone = sceneClone.children.find(child => child.isCamera);
      lidTimeline.value.progress(lidProgress);

      // console.log(sceneClone.children.find(child => child.isGroup))

      const screenshotRenderer = new THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
        gammaOutput: false,
        colorSpace: THREE.SRGBColorSpace,
        // Fixes material chipping issues, does not seem to affect performance much
        // SEE: https://threejs.org/examples/webgl_camera_logarithmicdepthbuffer.html
        logarithmicDepthBuffer: true,
        // Required for screenshot, see: https://stackoverflow.com/questions/26193702/three-js-how-can-i-make-a-2d-snapshot-of-a-scene-as-a-jpg-image
        // @TODO: Think about a workaround for this
        preserveDrawingBuffer: true
      });
      const screenshotControls = new CameraControls(cameraClone, renderer.domElement);
      cameraClone.aspect = 1;
      cameraClone.updateProjectionMatrix();
      const azimuthAngle = -Math.PI / 9;
      const polarAngle = Math.PI / 3;
      screenshotControls.rotateTo(azimuthAngle, polarAngle);
      screenshotControls.distance = baseControlsDistance / 3 + ssCameraDistanceFromBox.value;
      screenshotControls.update(1);
      const sizeWidth = 600;
      const sizeHeight = 600;
      screenshotRenderer.setSize(sizeWidth, sizeHeight);
      const clearColor = 0xFFFFFF;
      screenshotRenderer.setClearColor(clearColor, 1);
      fabricCanvases.value.forEach(canvas => {
        canvas.interactive = false;
        canvas.renderAll();
      });
      screenshotRenderer.render(sceneClone, cameraClone);
      fabricCanvases.value.forEach(canvas => {
        canvas.interactive = true;
        canvas.renderAll();
      });
      const preview3DCanvas = screenshotRenderer.domElement;
      const imageData = preview3DCanvas.toDataURL('image/jpg');
      setConfigurationScreenShotData(imageData);
      addHoverPanelIndication(hoveredPanel.value);

      // Dispose of cloned scene
      sceneClone.traverse(object => {
        if (object.geometry) {
          object.geometry.dispose();
        }
        if (object.material) {
          if (Array.isArray(object.material)) {
            object.material.forEach(material => {
              material.map?.dispose();
              material.dispose();
            });
          } else {
            object.material.dispose();
          }
        }
      });

      // Dispose of cloned camera
      cameraClone = null;

      // Dispose of renderer
      screenshotRenderer.dispose();
      $eventBus.$emit('screenshot-taken');
    }
    function onResize() {
      // The +2 for width is a fix for a white line on the left in Safari
      if (preview3dContainerEl.value) {
        camera.aspect = (preview3dWrapperEl.value.offsetWidth + 2) / preview3dWrapperEl.value.offsetHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(preview3dWrapperEl.value.offsetWidth + 2, preview3dWrapperEl.value.offsetHeight);
        isResized.value = true;
      }
    }
    function addDOMEventListeners() {
      preview3dContainerEl.value.addEventListener('resize', onResize);
      $eventBus.$on('panes-resized', onResize);
      $eventBus.$on('take-screenshot', takeScreenshot);
    }
    onMounted(() => {
      window.addEventListener('resize', onResize);
      initBoxObj();
      initScene();
      initBox(lidTimeline);
      lidTimeline.value?.play();

      // initMouse()

      addDOMEventListeners();
      setColorsFromTheme();
    });
    onBeforeUnmount(() => {
      stopAnim = true;
      $eventBus.$off('panes-resized');
      $eventBus.$off('take-screenshot');
      window.removeEventListener('resize', onResize);
      scene?.traverse(object => {
        if (object.geometry) {
          object.geometry.dispose();
        }
        if (object.material) {
          if (Array.isArray(object.material)) {
            object.material.forEach(material => {
              material.map?.dispose();
              material.dispose();
            });
          } else {
            object.material.dispose();
          }
        }
      });

      // Dispose of cloned camera
      camera = null;
      if (renderer) {
        preview3dContainerEl.value.removeChild(renderer.domElement);
        renderer.forceContextLoss();
        renderer.context = null;
        renderer.domElement = null;
        renderer = null;
      }
      if (lidTimeline.value) {
        lidBoolean.value = false;
        lidTimeline.value.reverse().clear();
      }
    });

    // Converts any angle to a value between 0 and 2π radians.
    function normalizeAngle(angle) {
      angle = angle % (2 * Math.PI);
      if (angle < 0) {
        angle += 2 * Math.PI;
      }
      return angle;
    }

    // Computes the shortest angular distance between two angles.
    function shortestAngleDifference(from, to) {
      const difference = normalizeAngle(to - from);
      if (difference > Math.PI) {
        return difference - 2 * Math.PI;
      }
      return difference;
    }
    watch(activePanel, value => {
      // Check if there is an active side and if there is a need to move the camera

      // Handle no information for camera angles
      if (isActivePanelInside.value && (value?.cameraRotationHInside === 'none' || value?.cameraRotationVInside === 'none')) {
        return;
      }
      if (!isActivePanelInside.value && (value?.cameraRotationH === 'none' || value?.cameraRotationV === 'none')) {
        return;
      }
      if (value?.height && value?.cameraRotationH !== 'none' && value?.cameraRotationV !== 'none') {
        controls.enabled = false;

        // eslint-disable-next-line new-cap
        const timeline = new gsap.timeline({
          onComplete: () => {
            controls.enabled = true;
          }
        });

        // const isOutside = isOutsideCanvasActive.value;
        const cameraRotationH = isActivePanelInside.value ? value.cameraRotationHInside : value.cameraRotationH;
        const cameraRotationV = isActivePanelInside.value ? value.cameraRotationVInside : value.cameraRotationV;
        const time = 0.9;
        const targetRotateH = cameraPositionsRotateH[cameraRotationH];
        const targetRotateV = cameraPositionsRotateV[cameraRotationV];
        const currentRotateH = normalizeAngle(controls.azimuthAngle); // camera's rotation around the vertical (Y) axis.
        const currentRotateV = normalizeAngle(controls.polarAngle); // camera's elevation or tilt from the top (Y-axis).

        const shortestRotateH = shortestAngleDifference(currentRotateH, targetRotateH);
        const shortestRotateV = shortestAngleDifference(currentRotateV, targetRotateV);
        const lid = isActivePanelInside.value ? 'open' : value.lid;
        if (lid === 'open') {
          lidBoolean.value = true;
          lidTimeline.value?.play();
        } else if (lid === 'closed') {
          lidBoolean.value = false;
          lidTimeline.value?.reverse();
        }
        timeline.to(controls, {
          duration: time,
          polarAngle: currentRotateV + shortestRotateV,
          ease: 'power1.inOut'
        }, 0);
        timeline.to(controls, {
          duration: time,
          azimuthAngle: currentRotateH + shortestRotateH,
          ease: 'power1.inOut'
        }, 0);
      }
    });
    function removeHoverPanelIndication() {
      scene.traverse(c => {
        if (c.isMesh) {
          const insideMatIndex = c.outsideMatIndex === 0 ? 1 : 0;
          c.material[c.outsideMatIndex].color.set(0xffffff);
          if (!hasInsidePrinting.value) {
            c.material[insideMatIndex].color.set(insideMaterialColor.value);
          } else {
            c.material[insideMatIndex].color.set(0xffffff);
          }
        }
      });
    }
    function addHoverPanelIndication(panelName) {
      scene.traverse(c => {
        if (c.isMesh) {
          const insideMatIndex = c.outsideMatIndex === 0 ? 1 : 0;
          if (c.panelName.split(" ")[0] === panelName) {
            if (!isHoveredPanelInside.value) {
              c.material[c.outsideMatIndex].color.set(0xffff00);
            } else {
              c.material[insideMatIndex].color.set(0xffff00);
            }
          }
        }
      });
    }
    watch(hoveredPanel, value => {
      scene.traverse(c => {
        if (c.isMesh) {
          removeHoverPanelIndication();
          addHoverPanelIndication(value);
        }
      });
      hasHoverPanelChanged.value = true;
    });
    watch(lidBoolean, value => {
      if (!lidTimeline.value) {
        return;
      }
      if (value) {
        lidTimeline.value.play();
      } else {
        lidTimeline.value.reverse();
      }
    });

    // @NOTE: BAD PRACTICE. Refactor this react to state change
    watch(theme, () => {
      setColorsFromTheme();
      isThemeChanged.value = true;
    });
    function onClickHandleFullscreen() {
      $eventBus.$emit("3d-fullscreen");
    }
    function dataURLToBlob(dataURL) {
      const byteString = atob(dataURL.split(',')[1]);
      const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], {
        type: mimeString
      });
    }
    $eventBus.$on('save-screenshot', async id => {
      takeScreenshot();
      if (configurationScreenshotData.value) {
        const image = dataURLToBlob(configurationScreenshotData.value);
        const formData = new FormData();
        formData.append('file', image, 'screenshot.png');
        await Adapter.saveScreenshot(formData, id);
      }
    });
    return (_ctx, _cache) => {
      const _component_PreviewToolbar = __unplugin_components_0;
      const _component_EditorButton = __unplugin_components_1;
      const _component_ButtonGroup = __unplugin_components_2;
      const _component_SvgIcon = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", {
        ref_key: "preview3dWrapperEl",
        ref: preview3dWrapperEl,
        class: "flex flex-col h-full"
      }, [props.isEditable ? (_openBlock(), _createBlock(_component_PreviewToolbar, {
        key: 0,
        class: "relative z-10"
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        ref_key: "preview3dContainerEl",
        ref: preview3dContainerEl,
        class: "absolute top-0 -left-[1px] h-full w-full z-10"
      }, null, 512), _createElementVNode("div", _hoisted_2, [_createVNode(_component_ButtonGroup, null, {
        default: _withCtx(() => [_createVNode(_component_EditorButton, {
          onClick: handleBoxLid
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(lidBoolean) ? 'Lid' : 'Lid'), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_ButtonGroup, null, {
        default: _withCtx(() => [_unref(windowWidth) >= _unref(mobileBreakpoint) ? (_openBlock(), _createBlock(_component_EditorButton, {
          key: 0,
          id: "preview-fullscreen",
          onClick: onClickHandleFullscreen
        }, {
          default: _withCtx(() => [_createVNode(_component_SvgIcon, {
            class: "w-[24px] h-[24px]",
            fill: "white",
            svgSymbolId: "fullscreen"
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })])])], 512);
    };
  }
};